export default function CloseIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 12 12" fill="none">
      <path
        d="M0.949666 9.43487C0.559145 9.82539 0.559131 10.4585 0.949666 10.8491C1.3402 11.2396 1.97336 11.2396 2.36388 10.8491L5.54586 7.6671C5.74109 7.47187 6.05774 7.47187 6.25297 7.6671L9.43495 10.8491C9.82547 11.2396 10.4586 11.2396 10.8492 10.8491C11.2397 10.4585 11.2397 9.82539 10.8492 9.43487L7.66718 6.25289C7.47195 6.05765 7.47195 5.74101 7.66718 5.54578L10.8492 2.3638C11.2397 1.97326 11.2397 1.34012 10.8492 0.949584C10.4586 0.559049 9.82548 0.559049 9.43495 0.949584L6.25297 4.13157C6.05774 4.3268 5.74109 4.3268 5.54586 4.13157L2.36388 0.949584C1.97334 0.559049 1.3402 0.559049 0.949666 0.949584C0.559131 1.34012 0.559131 1.97326 0.949666 2.3638L4.13165 5.54578C4.32688 5.74101 4.32688 6.05765 4.13165 6.25289L0.949666 9.43487Z"
        fill="rgba(0,0,255,1)"
        stroke="rgba(0,0,255,1)"
        strokeWidth="0"
      />
    </svg>
  );
}
